import translations from './const/en.json';

export default {
  translation: {
    ...translations
  }
}